export default {"src":"/_next/static/media/chevronDown.671c7d7b.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};